
import jwtDecode from 'jwt-decode';
import cookieReader from 'cookies-js';

import {BaseModel} from '../base/BaseModel';

/**
 * @class TokenModel
 * @extends BaseModel
 */
export class TokenModel extends BaseModel {

    initialize () {

        this.microservice = 'users';
        this.resource = 'tokens';
    }

    get idAttribute () {

        return 'uuid';
    }

    defaults () {

        let token = cookieReader.get(SECURITY_TOKEN_NAME);
        let isExpired = (token ? TokenModel.isTokenExpired(token) : false);

        return {
            token: (isExpired ? '' : token),
            decoded: (isExpired ? null : TokenModel.decodeToken(token)),
            gigyaToken: null
        };
    }

    exchangeGigyaToken () {

        let xhrSettings = {
            beforeSend: (jqXHR) => {
                jqXHR.setRequestHeader('DF_TOKEN', '');
            },
            headers: {
                'IGNORE_HTTP_ERROR': [400]
            }
        };

        return this.save(null, xhrSettings).done(() => {
            let options = {};

            // setting DF_TOKEN cookie to second level domain
            if (ENV !== 'local') {
                options = {
                    domain: TOKEN_DOMAIN
                };
            }

           cookieReader.set(SECURITY_TOKEN_NAME, this.get('token'), options);
           this.set('decoded', TokenModel.decodeToken(this.get('token')));
       });
    }

    toJSON () {

        return this.attributes.gigyaToken;
    }

    static decodeToken (token) {

        let parsed = {};

        try {
            parsed = jwtDecode(token);
        }
        catch (excpt) {

            parsed = {};
        }

        return parsed;
    }

    static isTokenExpired (token) {

        let parsed = TokenModel.decodeToken(token);

        if (parsed.exp) {

            return (parsed.exp < (Date.now() / 1000));
        }

        return true;
    }
}



// WEBPACK FOOTER //
// ./shared/model/users/TokenModel.js